export default __webpack_public_path__ + "static/share-8585a681b13288c25b859125577e8c90.jpg";